/*
  File: italiansecret-subscription-custom-drawer.js
  Purpose:
  Parallel subscription test clone of italiansecret_custom_drawer.js.
  It injects delivery date plus the Prometheus subscription mode/frequency
  summary into compatible cart drawers without modifying the original helper.
*/

(function () {
  const sessionKey = 'italiansecret_delivery_date';
  const modeKey = 'italiansecret_subscription_mode';
  const optionKey = 'italiansecret_subscription_option_id';

  function formatDateDisplay(dateString) {
    if (!dateString) return '';
    const date = new Date(dateString);
    return date.toLocaleDateString("en-GB", {
      weekday: "short",
      day: "numeric",
      month: "short",
      year: "numeric"
    });
  }

  function injectDeliveryDateLabel() {
    const deliveryDate = sessionStorage.getItem(sessionKey);

    // Find the "Selected Frequency" label
    const freqLabel = document.querySelector('.as-selling-plan-label');
    if (!freqLabel) return false;

    // Remove previous if exists
    let oldLabel = document.getElementById('italiansecret-subscription-cart-delivery-date-label');
    if (oldLabel) oldLabel.remove();
    const mode = localStorage.getItem(modeKey) || 'one_time';
    const optionId = localStorage.getItem(optionKey) || '';

    // Build new label
    const labelContainer = document.createElement('div');
    labelContainer.id = 'italiansecret-subscription-cart-delivery-date-label';
    labelContainer.innerHTML = `
      <label class="as-label as-block as-text-sm as-font-medium as-text-gray-700">Purchase mode</label>
      <div style="font-size:15px; color:#222; margin-top: 2px; margin-bottom: 8px;">${mode === 'subscription' ? 'Subscription' : 'One-off'}${mode === 'subscription' && optionId ? ' - ' + optionId.replace(/[-_]+/g, ' ') : ''}</div>
      <label class="as-label as-block as-text-sm as-font-medium as-text-gray-700">Delivery date</label>
      <div style="font-size:15px; color:#222; margin-top: 2px;">${deliveryDate ? formatDateDisplay(deliveryDate) : 'Not selected'}</div>
    `;

    // Insert just before Selected Frequency label
    freqLabel.parentNode.insertBefore(labelContainer, freqLabel);
    return true;
  }

  // Poll until the label is successfully injected, or until maxTries
  function pollInjectLabel(maxTries = 60, delay = 500) {
    let tries = 0;
    const poller = setInterval(() => {
      const injected = injectDeliveryDateLabel();
      tries++;
      // Stop if successful or max tries reached
      if (injected || tries >= maxTries) {
        clearInterval(poller);
      }
    }, delay);
  }

  // Utility: Run pollInjectLabel every time cart opens
  function setupCartOpenListener() {
    // You may want to tune this selector if your cart uses another class/id
    const cartDrawerSelector = '.as-border-t';

    // Listen for cart open, using event or by polling for cartDrawer in DOM
    let lastDrawerState = false;

    setInterval(() => {
      const drawer = document.querySelector(cartDrawerSelector);
      const nowOpen = drawer && drawer.offsetParent !== null; // visible in DOM

      // Cart just opened (or re-rendered), so poll inject
      if (nowOpen && !lastDrawerState) {
        pollInjectLabel();
      }
      lastDrawerState = nowOpen;
    }, 400);
  }

  document.addEventListener('DOMContentLoaded', setupCartOpenListener);

})();
